function N(o) {
  const c = o.regex, t = /^[a-zA-Z][a-zA-Z0-9-]*/, s = [
    "ALPHA",
    "BIT",
    "CHAR",
    "CR",
    "CRLF",
    "CTL",
    "DIGIT",
    "DQUOTE",
    "HEXDIG",
    "HTAB",
    "LF",
    "LWSP",
    "OCTET",
    "SP",
    "VCHAR",
    "WSP"
  ], A = o.COMMENT(/;/, /$/), E = {
    scope: "symbol",
    match: /%b[0-1]+(-[0-1]+|(\.[0-1]+)+)?/
  }, e = {
    scope: "symbol",
    match: /%d[0-9]+(-[0-9]+|(\.[0-9]+)+)?/
  }, T = {
    scope: "symbol",
    match: /%x[0-9A-F]+(-[0-9A-F]+|(\.[0-9A-F]+)+)?/
  }, a = {
    scope: "symbol",
    match: /%[si](?=".*")/
  }, n = {
    scope: "attribute",
    match: c.concat(t, /(?=\s*=)/)
  };
  return {
    name: "Augmented Backus-Naur Form",
    illegal: /[!@#$^&',?+~`|:]/,
    keywords: s,
    contains: [
      {
        scope: "operator",
        match: /=\/?/
      },
      n,
      A,
      E,
      e,
      T,
      a,
      o.QUOTE_STRING_MODE,
      o.NUMBER_MODE
    ]
  };
}
export {
  N as default
};
